module.exports = __webpack_public_path__ + "img/aa0c1fb.jpg";